import React, { useState, useEffect } from 'react';
import '../../../css/Preferences/RespondentPreference.css';
import Header from '../../Shared/Header';
import Footer from '../../Shared/Footer';
import Footer2 from '../../Shared/Footer2';
import { useSelector } from 'react-redux';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import TitleDescription from '../../../Data/Shared/TitleDescription.json';
import { ApiCall } from '../../../Services/utils/ApiCall';
import { utilityBaseURL } from '../../../Services/config/apiGateway';
import { SERVICE_PREFERENCES } from '../../../Services/config/apiEndPoints';
const RespondentPreference = props => {
    const manageProfileDataR = useSelector(state => state.manageProfileReducer.data);
    const [showDriverData, setShowDriverData] = useState(true);
    const [showTruckData, setShowTruckData] = useState(false);
    const [showRequesterData, setShowRequesterData] = useState(false);
    let [driversData, setDriversData] = useState([]);
    let [trucksData, setTrucksData] = useState([]);
    let [requestersData, setRequestersData] = useState([]);
    const renderDriverTableData = driversData?.map((data, index) => {
        const { companyName } = data
        return (
            <>
                <tr key={index} id="preferenceuserdata">
                    <td id="col1" className="tabledata">{index + 1}</td>
                    <td id="col2" className="tabledata">{companyName}</td>
                </tr>
            </>
        )
    });
    const renderTruckTableData = trucksData?.map((data, index) => {
        const { companyName } = data
        return (
            <>
                <tr key={index} id="preferenceuserdata">
                    <td id="col1" className="tabledata">{index + 1}</td>
                    <td id="col2" className="tabledata">{companyName}</td>
                </tr>
            </>
        )
    });
    const renderRequesterTableData = requestersData?.map((data, index) => {
        const { companyName } = data
        return (
            <>
                <tr key={index} id="preferenceuserdata">
                    <td id="col1" className="tabledata">{index + 1}</td>
                    <td id="col2" className="tabledata">{companyName}</td>
                </tr>
            </>
        )
    });
    const showDriverDetails = () => {
        setShowDriverData(true);
        setShowTruckData(false);
        setShowRequesterData(false);
    }
    const showTruckDetails = () => {
        setShowDriverData(false);
        setShowTruckData(true);
        setShowRequesterData(false);
    }
    const showRequesterDetails = () => {
        setShowDriverData(false);
        setShowTruckData(false);
        setShowRequesterData(true);
    }
    const getPreferences = () => {
        ApiCall(
            'GET',
            utilityBaseURL + SERVICE_PREFERENCES + `?role=${manageProfileDataR?.selectedProfileRoleName}&roleType=Respondent`,
            {},
            {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        ).then((apiData) => {
            if (apiData.flag != -1) {
                if (apiData.flag == 500) {
                    console.log('I am 500!');
                }
                else {
                    console.log('I am 200!');
                    let filteredRequesterData = apiData?.roleType?.filter((name, index) => "Requester" == name.roleName);
                    let filteredDriverData = apiData?.roleType?.filter((name, index) => "Driver" == name.roleName);
                    let filteredTruckData = apiData?.roleType?.filter((name, index) => "Truck" == name.roleName);
                    if (filteredRequesterData) {
                        setRequestersData(filteredRequesterData[0]?.dataList);
                    }
                    if (filteredTruckData) {
                        setTrucksData(filteredTruckData[0]?.dataList);
                    }
                    if (filteredDriverData) {
                        setDriversData(filteredDriverData[0]?.dataList);
                    }
                }
            }
        });
    }
    useEffect(() => {
        getPreferences();
    }, [])
    return (
        <div class="csoutercolor">
            <MetaDecorator title={TitleDescription.preferencesTitle} description={TitleDescription.preferencesDescription} />
            <Header tilesFetched={() => { }} />
            <div class="csnofullRespPref">
                <div id="csnobox1RespPref">
                    <div className='weathernavbar'>
                        <small id="weathername">Preferences </small>
                    </div><hr className='navbarhr' />
                    <div class="toppartRespPref">
                        <div class="respondentHeadingdiv">
                            <small class="respondentHeading">Your Preferred Partner</small>
                        </div>
                        <div class="toppartRespPrefOuterBox">
                            <div class="topPartButtonSection">
                                <div class={showDriverData ? "leftButtonDivRedBorder" : "leftButtonDiv"} onClick={showDriverDetails}>
                                    <small class={showDriverData ? "buttonNameRed" : "buttonNameBlack"}>Drivers</small>
                                </div>
                                <div class={showTruckData ? "midButtonDivRedBorder" : "midButtonDiv"} onClick={showTruckDetails}>
                                    <small class={showTruckData ? "buttonNameRed" : "buttonNameBlack"}>Trucks</small>
                                </div>
                                <div class={showRequesterData ? "rightButtonDivRedBorder" : "rightButtonDiv"} onClick={showRequesterDetails}>
                                    <small class={showRequesterData ? "buttonNameRed" : "buttonNameBlack"}>Requesters</small>
                                </div>
                            </div>
                            <div class="topPartMessageSection">
                                <div class="messageValueDiv">
                                    {showTruckData ?
                                        <small class="messageValue">You can add / delete Trucks in DTMS</small>
                                        :
                                        <div>
                                            {showRequesterData ?
                                                <small class="messageValue">Requesters who have selected you as their preferred partner</small>
                                                :
                                                <small class="messageValue">You can add / delete Drivers in DTMS</small>
                                            }
                                        </div>
                                    }
                                </div>
                            </div>
                            <div className="tableBoxDiv">
                                <table id='preferenceDetails'>
                                    <tbody>
                                        {showTruckData ? renderTruckTableData : showRequesterData ? renderRequesterTableData : renderDriverTableData}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="cs2footer11RespPref">
                <Footer />
            </div>
            <div class="cs2footer22RespPref">
                <Footer2 />
            </div>
        </div>
    );
};
export default RespondentPreference;